export default {"src":"/uk/_next/static/media/hybrid-app-intro-screen-three.676bfd66.svg","height":148,"width":300,"blurWidth":0,"blurHeight":0};